import { removeLastComma } from "./RemoveLastComma";

export const createUrl = (arr) => {
    let tempurl = '';
    arr.forEach((val) => {
        tempurl += `${val},`;
    });
    return removeLastComma(tempurl);
};
